import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/underwriter";
import l10n from "../../../l10n/localization";
import {Button} from "react-materialize";
import CompanyForm from "../CompanyForm";
import * as creationActions from "../../../actions/creation";
import * as utilsCommon from "../../../utils/utils";

class SelectCompanies extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(CompanyForm, null, creationActions.destroyingnewlyCreatedCompany())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_company">
                    {utilsCommon.notNullNorUndefined(this.props.schema.title) && this.props.schema.title !== '' ? this.props.schema.title : l10n.common.company}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_company"
                    value={this.props.formData}
                    options={utils.companyToSelect(this.props.companies)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(CompanyForm, props.value.item, creationActions.destroyingnewlyCreatedCompany())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        companies: state.company.companies,
        loading: state.company.loading
    });
})(SelectCompanies);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCompanies.js